import React, { FC } from 'react';
import classNames from 'classnames';
import './style.scss';
import { IconButtonProps } from './Icon.types';

const IconButton: FC<IconButtonProps> = ({
    className,
    children,
    style,
    onClick,
    color = 'primary',
    as: Tag = 'button',
}) => {
    const classes = classNames('sobrusPost__iconButton', color ? `sobrusPost__iconButton-${color}` : '', className);

    return (
        <Tag onClick={onClick} style={style} className={classes}>
            {children}
        </Tag>
    );
};

export { IconButton };
